







import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import InputGroup from '@/mixins/form/inputGroup'

@Component({
  components: {
    TextInput: () => import('@/components/common/inputs/TextInput.vue')
  }
})
export default class PatientProfileForm extends mixins(InputGroup) {
  @Prop(String) value!: string

  get inputPostCode1() {
    return (this.value || '').replace('-', '').slice(0, 3)
  }

  set inputPostCode1(value: string) {
    if (this.inputPostCode1 === value) return
    this.$emit('input', value + this.inputPostCode2)
  }

  get inputPostCode2() {
    return (this.value || '').replace('-', '').slice(3, 7)
  }

  set inputPostCode2(value: string) {
    if (this.inputPostCode2 === value) return
    this.$emit('input', this.inputPostCode1 + value)
  }
}
